export default "__VITE_ASSET__C767XMLD__"